<template>
  <div class="pt-3">
    <R-Toaster />
    <router-view v-if="!loadingCustomer"></router-view>
    <ModalCustomerLock
      :require-customer-token="$route.meta.requiresCustomerToken"
      :require-pbx="$route.meta.requiresPbx"
    />
    <ModalFeedback />
  </div>
</template>
<script>
import SideNav from "./components/menu/SideNav.vue";
import ModalCustomerLock from "./components/modals/ModalCustomerLock.vue";
import ModalFeedback from "./components/modals/ModalFeedback.vue";
import { DURATION, notify, TYPE } from "@8x8/oxygen-toaster";
import { mapActions, mapGetters } from "vuex";
import { PREFIX } from "@/vue/utils/defaultState";
import { addEventListener, EVENT_TYPES, triggerEvent } from "@/events";

export default {
  components: {
    SideNav,
    ModalCustomerLock,
    ModalFeedback,
  },
  computed: {
    ...mapGetters(["getUser", "getCustomer"]),
  },
  watch: {
    "getCustomer.cid"() {
      this.resetStore();
    },
  },
  data() {
    return {
      loadingCustomer: false,
      isIframe: false,
    };
  },
  async created() {
    // Redux <> Vuex sync before mounting react
    triggerEvent(EVENT_TYPES.SYNC_CUSTOMER, this.getCustomer);
  },
  async mounted() {
    addEventListener(EVENT_TYPES.OPEN_CUSTOMER_SELECT, () => {
      this.$bvModal.show("modal-customer-lock");
    });

    addEventListener(EVENT_TYPES.OPEN_FEEDBACK, () => {
      this.$bvModal.show("modal-feedback");
    });

    addEventListener(EVENT_TYPES.REACT_INITIATED_CUSTOMER_UPDATE, (event) => {
      const params = event?.detail;
      console.debug(`[React Sync Flow] Vue handler received params.`, params);
      this.fetchCustomer(params);
    });

    addEventListener(EVENT_TYPES.REACT_INITIATED_CUSTOMER_CLEAR, () => {
      this.clearCustomer();
    });

    this.isIframe = window.self !== window.top;
    triggerEvent(EVENT_TYPES.SYNC_IS_IFRAME, this.isIframe);
  },
  methods: {
    ...mapActions(["setUser", "fetchCustomer", "clearCustomer"]),
    async setupUser(authState) {
      if (!authState.idToken || !authState.accessToken) {
        return;
      }
      const user = JSON.parse(JSON.stringify(authState.idToken.claims));
      user.groups = [];
      if (authState.accessToken.claims?.groups) {
        user.groups = JSON.parse(
          JSON.stringify(authState.accessToken.claims?.groups)
        ); // Use groups from the Access Token, not ID Token
      }
      this.setUser(user);
    },
    fetchCustomerToken(authState) {
      if (!authState.idToken || !authState.accessToken) {
        return;
      }
      const customer = this.getCustomer;
      if (
        !customer ||
        !customer.lid ||
        this.$route.meta.requiresCustomerToken === false
      ) {
        return;
      }

      this.loadingCustomer = true;
      this.fetchCustomer({
        platform: customer.platform,
        customerId: customer.cid,
        pbx: customer.pbx,
        pbxList: customer.pbxList,
        adminList: customer.adminList,
        customerName: customer.customerName,
        tenantInfo: customer.tenantInfo,
        success: (response) => {
          this.loadingCustomer = false;
        },
        error: (response) => {
          console.log("got error lockCustomer");
          console.log(response);
          notify({
            content: `Could not create token for customer ${customer.customerName}: ${response}`,
            type: TYPE.error,
            duration: DURATION.INFINITE,
          });
          this.loadingCustomer = false;
        },
      });
    },
    resetStore() {
      const mutations = Object.keys(this.$store._mutations);
      mutations.forEach((mutation) => {
        if (!mutation.includes(PREFIX)) {
          return;
        }
        this.$store.commit(mutation);
      });
    },
  },
};
</script>
